import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import airplaneICon from '../assets/flight.png';
import airplaneICon2 from '../assets/flight2.png';

class RefundNav extends PureComponent {
  render() {
    const {lang} = this.props;
    return (
      <div
        style={{
          width: '100%',
          overflow: 'hidden',
          minHeight: '0.9rem',
          marginTop: '-2px',
          paddingTop: '20px',
          textAlign: "center"
        }}
      >
        <div
          ref="navBarHeight"
          className={`ref_navbar_nav ${this.props.navStyle || 'nav1'}`}
          style={{ float: 'left' }}
        >
          {/* <div className="ref_navbar_line">
            <div className="ref_navbar_lineLeft ">
              <span className='sc'></span>
            </div>
            {this.props.navStyle!=='nav3'? (<div className='lefts'>
              <div className='solidb'></div>
              <img alt="" src={airplaneICon2}/>
              <div className='solidc1'></div>
            </div>):(<div className='lefts'>
              <div className='solidf'></div>
            </div>)}
            {this.props.navStyle!=='nav3'? (<div className="ref_navbar_lineRight ">
              <span className='nextC'></span> 
            </div>):<div className="ref_navbar_lineRight ">
              <span className='nextf'></span> 
            </div>}
          </div> */}
          <div className="ref_RefundNavbar_tips">
            {this.props.navStyle !== 'nav3' ? (
              <div className="flight_img" />
            ) : null}
            <div className="left">
              <div className="left_cont">
                <div className="left_line" />
                <span className="sc" />
              </div>
              {/* <img alt="" src={airplaneICon2}/> */}
              <span className="ref_navbar_tips1" style={{ color: '#008ACB' }}>
                {lang.fillInfo}
              </span>
            </div>
            <div className="line">
              <div className="line_left_" />
              <div className="line_left_" />
            </div>
            <div className="line">
              <div
                className={
                  this.props.navStyle !== 'nav3' ? 'line_right' : 'line_left_'
                }
              />
              <div
                className={
                  this.props.navStyle !== 'nav3' ? 'line_right' : 'line_left_'
                }
              />
            </div>
            <div className="right">
              <div className="right_cont">
                <div
                  className={
                    this.props.navStyle !== 'nav3'
                      ? 'right_line'
                      : 'right_line_'
                  }
                />
                {this.props.navStyle !== 'nav3' ? (
                  <span className="nextC" />
                ) : (
                  <span className="nextCF" />
                )}
              </div>
              <span
                className="ref_navbar_tips3"
                style={
                  this.props.navStyle !== 'nav3'
                    ? { color: '#262626' }
                    : { color: '#008ACB' }
                }
              >
                {lang.updateDetail86}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RefundNav.PropTypes = {
  navStyle: PropTypes.string,
  airplaneICon: PropTypes.string,
  lang: PropTypes.object,
};

export default RefundNav;



// WEBPACK FOOTER //
// ./src/components/RefundNav/index.js